'use strict';
var groove;
angular.module('shiftTraderApp', []);

angular.module('shiftTraderPrintApp', ['ngResource', 'ngCookies', 'shiftTraderApp', 'shiftTraderApp.filters',
  'angularytics', 'angularLocalStorage', 'ui.bootstrap',  'ui.router', 'ngAnimate', 'uuid4', 'toastr'])
  .config(['$stateProvider', '$provide', 'AngularyticsProvider', '$urlRouterProvider', '$compileProvider', function ($stateProvider, $provide, AngularyticsProvider, $urlRouterProvider, $compileProvider) {
    AngularyticsProvider.setEventHandlers(['Console', 'GoogleUniversal']);

    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|sms|mms):/);

    $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function($delegate, $injector) {
      return function(exception, cause) {
        $delegate(exception, cause);
        console.log(exception);

        var $uibModalStack = $injector.get('$uibModalStack');
        var Session = $injector.get('Session');
        var $location = $injector.get('$location');

        var context = {};
        if ($uibModalStack.getTop()) {
          context.topModal = {
            templateUrl: $uibModalStack.getTop().windowTemplateUrl,
            size: $uibModalStack.getTop().size
          };
        }

        context.path = $location.path();
        context.url = $location.url();
        context.absUrl = $location.absUrl();

        context.isLoggedIn = Session.isLoggedIn().toString();
        var userData = {};
        if (Session.isLoggedIn() && Session.me) {
          userData.id = Session.getCurrentUserId();
          userData.username = Session.me.name;
          userData.email = Session.me.email;
          context.orgId = Session.getCurrentOrgId();

          if (context.orgId) {
            var memb = lodash.find(Session.me.memberships, {organization_id: context.orgId});
            if (memb) {
              context.orgName = memb.organization.name;
            }
          }

          Rollbar.configure({payload: { person: userData}});
        }

        Rollbar.error(exception, {payload: context});
      };
    }]);

    $urlRouterProvider.otherwise('/schedulePrint/' + moment().format('YYYY-MM-DD'))
        .when('/schedulePrint', '/schedulePrint/' + moment().format('YYYY-MM-DD'));

    $stateProvider
      .state('schedulePrint', {
        abstract: true,
        template: '<div ui-view></div>',
        url: '/schedulePrint',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          allPositions: ['Positions', function(Positions) {
            return Positions.getAllInOrg();
          }],
          allUsers: ['Users', function(Users) {
            return Users.getAll({view: 'med'});
          }],
          org: ['Organizations', function(Organizations) {
            return Organizations.getCurrentOrg();
          }]
        }
      })
      .state('schedulePrint.date', {
        url: '/:date',
        templateUrl: 'views/schedulePrint.html',
        controller: 'SchedulePrintCtrl',
        resolve: {
          allWorkPeriods: ['WorkPeriodStore', '$stateParams', 'TimeService', 'me', function(WorkPeriodStore, $stateParams, TimeService, me) {
            // have 'me' as a dependency so that we load Session with correct timezone before workPeriods get initiaized
            console.log('starting allWorkPeriods function', moment().format('ss SSS'));
            var dateProvided = moment($stateParams.date);
            var twix;
            if (dateProvided.isValid()) {
              twix = TimeService.getWeekTwixFromMoment(dateProvided, 1, 0);
              return WorkPeriodStore.getWorkPeriodsBetween(twix.start, twix.end);
            } else {
              twix = TimeService.getWeekTwixFromMoment(moment.utc(), 1, 0);
              return WorkPeriodStore.getWorkPeriodsBetween(twix.start, twix.end);
            }
          }],
          theDate: ['$stateParams', 'TimeService', 'org', function($stateParams, TimeService, org) {
            // require 'org' here so that we know the timezone has been set before this function gets called...
            var tempDate = TimeService.getBeginningOfDayFromDate(moment($stateParams.date));
            if (tempDate.isValid()) {
              return tempDate;
            } else {
              return TimeService.getBeginningOfDayFromDate(moment.utc());
            }
          }]
        }
      })
      .state('deploymentSheet', {
        abstract: true,
        template: '<div ui-view></div>',
        url: '/deploymentSheet',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          allPositions: ['Positions', function(Positions) {
            return Positions.getAllInOrg({status:'any'});
          }],
          allUsers: ['Users', function(Users) {
            return Users.getAll({view: 'med'});
          }],
          org: ['Organizations', function(Organizations) {
            return Organizations.getCurrentOrg();
          }]
        }
      })
      .state('deploymentSheet.date', {
        url: '/:date',
        templateUrl: 'views/deploymentSheet.html',
        controller: 'DeploymentSheetCtrl',
        resolve: {
          allWorkPeriods: ['WorkPeriodStore', '$stateParams', 'TimeService', 'me', function(WorkPeriodStore, $stateParams, TimeService, me) {
            // have 'me' as a dependency so that we load Session with correct timezone before workPeriods get initiaized
            //console.log('starting allWorkPeriods function', moment().format('ss SSS'));
            var dateProvided = moment($stateParams.date);
            var dt;
            //console.log('dateProvided', dateProvided.format());
            if (moment(dateProvided).isValid()) {
              dt = TimeService.getBeginningOfDayFromDateWithOrgSetting(dateProvided);
              return WorkPeriodStore.getWorkPeriodsBetween(dt, dt);
            } else {
              dt = TimeService.getBeginningOfDayFromDateWithOrgSetting(moment.utc());
              return WorkPeriodStore.getWorkPeriodsBetween(dt, dt);
            }
          }],
          theDate: ['$stateParams', 'TimeService', 'org', function($stateParams, TimeService, org) {
            // require 'org' here so that we know the timezone has been set before this function gets called...
            var tempDate = TimeService.getBeginningOfDayFromDateWithOrgSetting(moment($stateParams.date));
            if (tempDate.isValid()) {
              return tempDate;
            } else {
              return TimeService.getBeginningOfDayFromDateWithOrgSetting(moment.utc());
            }
          }]
        }
      })
      .state('setHostnameAndEnv', {
        url: '/setHostnameAndEnv/:hostname/:env',
        resolve: {
          setBackend: ['$location', '$stateParams', 'ServerUrls', 'Session', '$state',
            function($location, $stateParams, ServerUrls, Session, $state) {
              if (ServerUrls.isHostnameDefined($location.host())) {
                $state.go('schedulePrint.date', {date: moment().format('YYYY-MM-DD')});
              } else {
                ServerUrls.setHostname($stateParams.hostname);
                ServerUrls.setEnv($stateParams.env);
                Session.logout();
              }
            }]
        }
      })
      .state('login', {
        url: '/login',
        template: '<h3>Please close this tab and re-open the schedule print view from the schedule view.</h3>'
      });
  }])
  .run(['Angularytics', '$rootScope', '$location', '$state', 'ServerUrls', '$interval', 'ClientTypeDetectionService',
    function(Angularytics, $rootScope, $location, $state, ServerUrls, $interval, ClientTypeDetectionService) {
      Angularytics.init();

      $rootScope.$on('$stateChangeStart', function() {
        $rootScope.isLoading = true;
      });


      lodash.each(['$stateChangeSuccess', '$stateChangeError'], function(t) {
        $rootScope.$on(t, function(event, toState, toParams, fromState, fromParams, error) {
          if (t === '$stateChangeError') {
            console.log(error);
          }
          $rootScope.isLoading = false;
        });
      });

      $rootScope.goToLogin = function() {
        console.log('$rootScope.goToLogin');
        $('body').addClass('needs_login');
      };

      var errorInitInterval = $interval(function() {
        if (window.Rollbar && !window.Rollbar.onload && ServerUrls.matchingServerHost()) {
          window.Rollbar.configure({payload: { environment: ServerUrls.getCurrentErrorEnv()}});
          window.Rollbar.configure({payload: {client_type: ClientTypeDetectionService.getBrowserCharacteristics()}});

          var matchingServer = ServerUrls.matchingServerHost();
          if (lodash.isUndefined(matchingServer) || matchingServer.name === 'development') {
            window.Rollbar.configure({enabled: false});
          }

          $interval.cancel(errorInitInterval);
        }
      }, 100);
  }]);
